import { registerRootComponent } from 'expo';
import { Platform } from 'react-native';
import { preventNativeSplashAutoHide } from './src/utils/splashScreen';
import App from './App';

if (Platform.OS !== 'web') {
  preventNativeSplashAutoHide();
}

// Initialize Firebase background message handler
// This must be imported before App to register the handler
if (Platform.OS !== 'web') {
  require('./src/lib/notificationHandler');
}

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
